function store_clicks(click_url, click_text, page_url, page_type) {
  dataLayer.push(
    {
      "event": "store_clicks",
      "data": {
        "page_type": page_type,
        "page_url": page_url,
        "click_url": click_url,
        "click_text": click_text
      }
    }
  );
}

function social_clicks(page_type, social_platform) {
  dataLayer.push(
    {
      "event": "social_clicks",
      "data": {
        "page_type": page_type,
        "social_platform": social_platform
      }
    }
  );
}

function store_search(page_type, search_term) {
  dataLayer.push(
    {
      "event": "store_search",
      "data": {
        "page_type": page_type,
        "search_term": search_term
      }
    }
  );
}

function partner_order(pageType, sku, itemName, itemBrand, category, category, variant, price) {
  dataLayer.push(
    {
      "event": "partner_order",
      "data": {
        "page_type": pageType,
        "page_type": pageType,
        "pdp_id": sku,
        "pdp_name": itemName,
        "pdp_brand": itemBrand,
        "pdp_category": category,
        "pdp_variant": variant,
        "pdp_price": price
      }
    }
  );
}

function find_store(pageType, sku, itemName, itemBrand, category, variant, price) {
  dataLayer.push(
    {
      "event": "find_store",
      "data": {
        "page_type": pageType,
        "pdp_id": sku,
        "pdp_name": itemName,
        "pdp_brand": itemBrand,
        "pdp_category": category,
        "pdp_variant": variant,
        "pdp_price": price
      }
    }
  );
}

function partner_click(partnerUrl, partnerName, pageType) {
  dataLayer.push(
    {
      "event": "partner_click",
      "data": {
        "click_url": partnerUrl,
        "partner_name": partnerName,
        "page_type": pageType
      }
    }
  );
}

function begin_keuzehulp(keuzehulpName, pageType) {
  dataLayer.push(
    {
      "event": "begin_keuzehulp",
      "data": {
        "keuzehulp_name": keuzehulpName,
        "page_type": pageType
      }
    }
  );
}

function producten_filters(filterName, pageType) {
  dataLayer.push(
    {
      "event": "producten_filters",
      "data": {
        "page_type": pageType,
        "filter_name": filterName
      }
    }
  );
}

function producten_sorteren(filterName, pageType) {
  dataLayer.push(
    {
      "event": "producten_sort",
      "data": {
        "page_type": pageType,
        "filter_name": filterName
      }
    }
  );
}

function reserve_product(pageType, productName) {
  dataLayer.push(
    {
      "event": "reserve_product",
      "data": {
        "page_type": pageType,
        "product_name": productName
      }
    }
  );
}

function newsletter_submit(pageType) {
  dataLayer.push(
    {
      "event": "newsletter_submit",
      "data": {
        "page_type": pageType
      }
    }
  );
}

function select_item(pageType, currency, value, itemListId, itemListName, items) {
  dataLayer.push(
    {
      "event": "select_item",
      "data": {
        "page_type": pageType,
        "currency": currency,
        "value": value,
        "item_list_id": itemListId,
        "item_list_name": itemListName,
        "items": [
          items
        ]
      }
    }
  );
}

function view_item_list(pageType, currency, itemListId, itemListName, productTitle, productPrice, productVendor, productCollectionTitle, productSku) {
  dataLayer.push(
    {
      "event": "view_item_list",
      "data": {
        "page_type": pageType,
        "currency": currency,
        "item_list_id": itemListId,
        "item_list_name": itemListName,
        "items": [
          {
            "product_name": productTitle,
            "sku": productSku,
            "price": productPrice,
            "vendor": productVendor,
            "category": productCollectionTitle
          }
        ]
      }
    }
  );
}